module.exports = "<p>\n  shared works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/shared.component.html
// module id = 1117
// module chunks = 0 1 2 3 4 5 6 7